/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StorageBusinessObjectDefinitionDailyUploadStat { 
    /**
     * The upload date in YYYY-MM-DD format
     */
    uploadDate: Date;
    /**
     * The Namespace that Business Object Definition is associated with
     */
    namespace: string;
    /**
     * The name of the Data Provider that Business Object Definition is associated with
     */
    dataProviderName: string;
    /**
     * The name of the Business Object Definition
     */
    businessObjectDefinitionName: string;
    /**
     * The total number of files uploaded to the storage on the date specified
     */
    totalFiles?: number;
    /**
     * The total number of bytes uploaded to the storage on the date specified
     */
    totalBytes?: number;
}
